import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=89fddc5c&scoped=true&"
import script from "./AppPagination.vue?vue&type=script&lang=ts&"
export * from "./AppPagination.vue?vue&type=script&lang=ts&"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=89fddc5c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fddc5c",
  null
  
)

export default component.exports